






















































































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { doublePrevention, hiddenDangerLibraryServer, performanceServer } from '@/api/installServer';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import publishObjectPath from '@/util/configRegistry'; // 导入过渡函数

@Component({
  components: { CollapseTransition },
})
export default class Dialog2 extends Vue {
  private dialogVisible = false;
  // 表单数据
  private formData: any = {};
  hazardStatus: any = {
    CREATED: '已创建',
    ISSUED: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
    OTHERWISE: '另行办结',
  }; // 隐患状态

  private basicInfoShow: any = true;
  private rectifyInfoShow: any = true;
  imgPath: any = publishObjectPath.imgPathWater;

  public async showDialog(data: any) {
    this.formData = data;
    this.$set(this.formData, 'initiateImagesData', []);
    this.$set(this.formData, 'rectifyPictureFile', []);
    if (this.formData.hazardPicture) {
      this.getHazardPic(this.formData.hazardPicture, 'hazardPicture');
    }
    if (this.formData.rectifyPicture) {
      this.getHazardPic(this.formData.rectifyPicture, 'rectifyPicture');
    }
    this.dialogVisible = true;

  }
  getHazardPic(ids: any, type: any) {
    performanceServer.getSysFile(ids).then((res: any) => {
      if (type === 'hazardPicture') {
        this.formData.initiateImagesData = res.data;
      }
      if (type === 'rectifyPicture') {
        this.formData.rectifyPictureFile = res.data;
      }
    });
  }
  handleClose(done: any) {
    done();
  }
}
